import { xcss } from "@atlaskit/primitives";

export const boxStyles = xcss({
    color: "color.text",
    backgroundColor: "elevation.surface.raised",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border.accent.gray",
    padding: "space.100",
    borderRadius: "border.radius.100",
    transitionDuration: "200ms",
    listStyle: "none",    
    ":hover": {
      backgroundColor: "color.background.accent.gray.subtlest.hovered",
      color: "color.text.inverse",
      transform: "scale(1.02)",
    },
  });

  export const boxStyles2 = xcss({
    color: "color.text",
    backgroundColor: "color.background.input",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border.discovery",
    padding: "space.100",
    borderRadius: "border.radius.100",
    transitionDuration: "200ms",
    listStyle: "none",    
    ":hover": {
      backgroundColor: "color.background.discovery.bold.hovered",
      color: "color.text.inverse",
      transform: "scale(1.02)",
    },
  });

export const listStyles = xcss({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.raised',
    padding: 'space.150',
    transition: '200ms',
    borderRadius: 'border.radius.100',
    boxShadow: 'elevation.shadow.raised',
    ':hover': {
      backgroundColor: 'elevation.surface.hovered',
    },
  });